<template>
  <v-content style="background-color: #f4f4ee">
    <v-container class="d-flex fill-height">
      <v-row align="center" justify="center">
        <v-card max-width="360" width="100%" tile>
          <v-form @submit.prevent="login">
            <v-card-title>
              <AppLogo />
              <span class="ml-4">Logga in</span>
            </v-card-title>
            <v-card-text>
              <v-text-field label="Användare" v-model="model.email" />
              <v-text-field
                label="Lösenord"
                type="password"
                autocomplete
                v-model="model.password"
              />
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn :loading="pendingLogin" tile color="primary" type="submit"
                >Logga in</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-row>
    </v-container>
    <v-snackbar color="error" v-model="errorShow">
      {{ errorMessage }}
    </v-snackbar>
  </v-content>
</template>

<script>
import AppLogo from '@/components/AppLogo'
import gql from 'graphql-tag'

export default {
  name: 'Login',

  components: {
    AppLogo
  },

  data: () => ({
    pendingLogin: false,
    errorShow: false,
    errorMessage: null,
    model: {
      email: '',
      password: ''
    }
  }),

  methods: {
    async login() {
      this.errorShow = false
      this.pendingLogin = true
      try {
        const {
          data: {
            login: { token }
          }
        } = await this.$apollo.mutate({
          mutation: gql`
            mutation($email: String!, $password: String!) {
              login(email: $email, password: $password) {
                token
              }
            }
          `,
          variables: this.model
        })
        this.$store.dispatch('user/login', token)
      } catch (error) {
        this.errorMessage = error.graphQLErrors[0].message
        this.errorShow = true
        this.pendingLogin = false
      }
    }
  }
}
</script>
